import { baseUrl } from "./meta";
import axios from "axios";
import { setError, setLoading, setSuccess } from "../redux/actions/highlights";
import { setForgotEmailStatus, setLogin } from "../redux/actions/auth";
import { setHeatmap, setHeatmapLoader } from '../redux/actions/heatmapActions';
import { setFootfall, setFootfallGraph, setFootfallLoader } from '../redux/actions/footfallActions';
import { setCategory, setCategoryGraph, setCategoryLoader } from '../redux/actions/categoryActions';
import { setComparison, setComparisonLoader, setGroupComparison } from '../redux/actions/comparisonActions';
import { enums, storage } from "./common";
import { setSummary } from "../redux/actions/summary";
import { createFilter, deleteFilter, listFilter } from "../redux/actions/savedFilters";
import { setClientUsers } from "../redux/actions/user";
import { setNewUser, setSpace, setSpaces } from "../redux/actions/spaces";
import { setLogoUrl } from "../redux/actions/logo";
import { getSystemFeatures } from "../redux/actions/systemfeatures";
import { setInsights } from "../redux/actions/insights";
import { setEmploye, setFloor, setFloors } from "../redux/actions/floorAction";

import { setConversionDailyData, setConversionData, setConversionLoader, setConversionTotal } from "../redux/actions/conversionActions";
import { getGraphOfEmployeActivity, getSectionsOfEmploye, setGraphLoader } from "../redux/actions/employeActivity";
import { setEmployeeSaleUnit } from "../redux/actions/categoryAction";


const defaultUser = { login: false, token: "" };
export var user = storage.getParsed(enums.USER, defaultUser);
const setHighlights = (payload, dispatch, success, error) => {
    if (payload.status == true) {
        dispatch(success(payload));
    } else {
        dispatch(setError(payload.message));
        error(payload.data);
    }
};

export const loginRequest = async (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    var payload;
    await axios({
        method: 'post',
        url: baseUrl + 'users/authenticate',
        data: requestData.params
    }).then((response) => {
        payload = response.data;
        dispatch(setLoading(false));
        if (payload.status) {
            user = payload.data
            dispatch(setLogin(payload.data));
            dispatch(setError(''));
        }
        else {
            dispatch(setError(payload.message));
        }


    })


        // (function (response) {
        //     payload = response.data;
        //     dispatch(setLoading(false));
        //     if(payload.status) {
        //         console.log('imrunning',user);
        //         user = payload.data;
        //     }
        //     if (payload.status) {

        //         dispatch(setLogin(payload.data));

        //     } else {
        //         dispatch(setError(payload.message));
        //     }

        // })

        .catch(function (error) {
            dispatch(setLoading(false));                                                                                           
            if (error.response) {
                payload = error.response.data;
                dispatch(setError(error.response.data.message));
                console.log(error?.response?.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request); 
            } else {
                dispatch(setError('password incorrect'));
            }
            console.log(error.config);
        });
    return payload;
}

export const summaryRequest = async (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    var response = await axios({
        method: 'post',
        url: baseUrl + 'footfall/totalSummary',
        data: requestData.params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + user.token,
        }
    });
    dispatch(setLoading(false));
    let data = response.data.data;
    data["user"] = user;
    dispatch(setSummary(data));
    return response.data;
}

export const listFilterRequest = async (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    var response = await axios({
        method: 'get',
        url: baseUrl + 'filter',
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + user.token,
        }
    }).catch(function (error) {
        // console.log(error.message);
        dispatch(setError(error.message));
    });
    dispatch(setLoading(false));
    dispatch(listFilter(response.data.data));
    return response.data;
}

export const spacesRequest = (requestData) => {

    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token }
    };

    fetch(`${baseUrl}spaces?client_id=${requestData.client_id}&limit=1000`, requestOptions).then(res => {
        return res.json();
    }).then(data => {
        //   requestData.dispatch(setLoader(false))
        requestData.dispatch(setSpaces(data.data.docs))
    }).catch(err => {
    });
}

export const logoUrlRequest = (requestData) => {
    const requestOptions = {
        method: 'POST',
        body: requestData.params,
        headers: { "Authorization": "Bearer " + user.token },
    };

    fetch(`${baseUrl}media/client`, requestOptions).then(res => {
        return res.json();
    }).then(data => {
        requestData.dispatch(setLogoUrl(data.data.url))
    }).catch(err => {
     // console.log(err)
    })
}
export const usersRequest = (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };
    fetch(`${baseUrl}users?page=1&limit=30&client_id=${requestData.client_id}`, requestOptions).then(res => {
        return res.json();
    }).then(data => {
        if (data.status == true) {
            requestData.dispatch(setClientUsers(data.data.docs))
            dispatch(setLoading(false));
        }
    }).catch(err => {
        dispatch(setError(true))
       // console.log(err)
    })
}



export const addUserRequest = (requestData) => {
    var dispatch = requestData.dispatch;
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token }
    };

    fetch(`${baseUrl}users/register`, requestOptions).then(res => {
        return res.json()
    })
        .then(data => {
            dispatch(setSuccess(data.message));
            if (data.status == true) {
                usersRequest(requestData);
            }
        }).catch(err => {
            dispatch(setError(true))
           // console.log(err)
        })
}

export const userUpdateRequest = (requestData) => {
    var dispatch = requestData.dispatch;
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(`${baseUrl}users/${requestData._id}`, requestOptions).then(res => {
        return res.json();
    }).then(data => {
        dispatch(setSuccess(data.message));
        if (data.status == true) {
            requestData.dispatch(setNewUser(data.data))
            // usersRequest(requestData);
        }
    }).catch(err => {
        dispatch(setError(true))
       // console.log(err)
    })
};

export const userDeleterequest = (requestData) => {
    var dispatch = requestData.dispatch;
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(`${baseUrl}users/${requestData._id}`, requestOptions).then(res => {
        return res.json();
    }).then(data => {
        dispatch(setSuccess(data.message))
        if (data.status === true) {
            usersRequest(requestData);
        }
    }).catch(err => {
        dispatch(setError(err.message))
       // console.log(err)
    })
};

export const updateUserpassword = (requestData) => {
    var dispatch = requestData.dispatch;
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + 'users/updatePassword', requestOptions).then(res => {
        return res.json();
    }).then(data => {
        dispatch(setSuccess(data.message))
        if (data.status) {
            dispatch(setSuccess(data.message))
        }
    }).catch(err => {
        dispatch(setError(err.message))
       // console.log(err)
    })
}


export const createFilterRequest = async (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    var response = await axios({
        method: 'post',
        url: baseUrl + 'filter',
        data: requestData.params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + user.token,
        }
    }).catch(function (error) {
        console.log(error.message);
        dispatch(setError(error.message));
    });
    dispatch(setLoading(false));
    dispatch(createFilter(response.data));
    return response.data;
};

export const deleteFilterRequest = async (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    var response = await axios({
        method: 'delete',
        url: baseUrl + 'filter/' + requestData.params.id,
        headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + user.token,
        }
    });
    dispatch(setLoading(false));
    return response.data;
};

export const systemFeaturesRequest = (requestData) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(`${baseUrl}feature/?page=1&limit=1000`, requestOptions).then(res => {
        return res.json()
    }).then(data => {
        if (data.status) {
            requestData.dispatch(getSystemFeatures(data.data.docs))
        }
    })
}

export const passwordForgetRequest = (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    const requestOptions = {
        method: 'POSt',
        body: JSON.stringify({ email: requestData.email }),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(`${baseUrl}users/forgot`, requestOptions).then((res) => {
        if (res.status === 200) {
            console.log('status',res.status);
            dispatch(setLoading(false));
            requestData.dispatch(setForgotEmailStatus(res));
        }
        return res.json()
    }).then(data => {
        dispatch(setLoading(false));
        if (!data.status) {
            requestData.dispatch(setForgotEmailStatus(data));
        }
    }).catch(err => {
       // console.log(err);
    })
}

export const resetPasswordRequest = (requestData) => {
    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));
    var dispatch = requestData.dispatch;
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + requestData.token },
    };

    fetch(baseUrl + 'users/resetPassword', requestOptions).then(res => {
        return res.json();

    }).then(data => {
        dispatch(setLoading(false));
        if (data.status) {
            dispatch(setSuccess(data.message))
        }
    }).catch(err => {
        dispatch(setError(err.message))
       // console.log(err)
    })
}

export const heatmapRequest = (requestData) => {
    // dispatch(setLoading(true));
    requestData.dispatch(setLoading(true));
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData.params),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };
    fetch(baseUrl + "heatmap/getHeatmap", requestOptions).then(res => {
        return res.json();
    }).then(data => {
        requestData.dispatch(setLoading(false));
        if (data.status == true) {
            requestData.dispatch(setHeatmap(data.data));
        }
    }).catch(err => {
        requestData.dispatch(setLoading(false));
        console.warn(err);
    });
};

export const footfallRequest = (requestData) => {
    requestData.dispatch(setLoading(true));
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "footfall/getCount", requestOptions).then(res => {
        return res.json();
    }).then(data => {
        if (data.status == true) {
            requestData.dispatch(setLoading(false));
            requestData.dispatch(setFootfall(data.data));
        }
        requestData.dispatch(setFootfallLoader(false));
    }).catch(err => {
        console.warn(err);
        requestData.dispatch(setFootfallLoader(false));
        requestData.dispatch(setLoading(true));
    });
};

export const footfallGraphRequest = (requestData) => {

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "footfall/lineGraph", requestOptions).then(res => {
        return res.json();
    }).then(data => {
        if (data.status === true) {
            requestData.dispatch(setFootfallGraph(data.data));
        }
    }).catch(err => {
        console.warn(err);
    });
};

export const categoryRequest = (requestData) => {
    delete requestData?.sec_id;

    var dispatch = requestData.dispatch;
    dispatch(setLoading(true));

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "dwelltime/getCount", requestOptions).then(res => {
        return res.json();
    }).then(data => {
        dispatch(setLoading(false));
        if (data.status == true) {
            // let _data = data.data.map((item) => 
            // {
            //     return {...item, footfall: item.footfall/3}
            // })
           
            requestData.dispatch(setCategory(data.data));
        }
        requestData.dispatch(setCategoryLoader(false));
    }).catch(err => {
        dispatch(setLoading(false));
        console.warn(err);
        requestData.dispatch(setCategoryLoader(false));
    });
};

export const categoryGraphRequest = (requestData) => {
    var dispatch = requestData.dispatch;

    dispatch(setLoading(true));

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "dwelltime/lineGraph", requestOptions).then(res => {
        return res.json();
    }).then(data => {
        dispatch(setLoading(false));
        if (data.status == true) {
            requestData.dispatch(setCategoryGraph(data.data));
        }
    }).catch(err => {
        dispatch(setLoading(false));
        console.warn(err);
    });
};


export const comparisonRequest = (requestData) => {
    console.log('requestData',requestData);
    var dispatch = requestData.dispatch;
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData.params),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "footfall/compare", requestOptions).then(res => {
        return res.json();
    }).then(data => {
        if (data.status === true) {
            if (requestData.params.type === "single") {
                requestData.dispatch(setComparison(data.data));
            } else {
                console.log('data.data',data.data);
                requestData.dispatch(setGroupComparison(data.data));
            }
        } else {
            requestData.dispatch(setComparisonLoader(false));
        }
    }).catch(err => {
        requestData.dispatch(setComparisonLoader(false));
        console.warn(err);
    });
};


export const insightRequest = (requestData) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "footfall/insights", requestOptions).then(res => {
        return res.json()
    }).then(data => {
        if (data.status === true) {

            requestData.dispatch(setInsights(data.data))
        }
    }).catch(err => {
       // console.log(err);
    })


}

export const authenticationRequest = (requestData) => 
{
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "users/updateToken", requestOptions).then(res => {
        return res.json()
    }).then(data => {
        if (data.status === true) {
            user = data.data
            requestData.dispatch(setLogin(data.data));
            //   requestData.dispatch(setInsights(data.data))
        }
    }).catch(err => {
       // console.log(err);
    })


}

export const singleFloorFetch = (requestData) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token }
    };

    fetch(`${baseUrl}floors/${requestData._id}`, requestOptions).then(res => {
        return res.json();
    }).then(data => {
        requestData.dispatch(setFloor(data.data))

    }).catch(err => {
       // console.log(err);
    })
}
export const floorRequest=(requestData) => {

    // requestData.dispatch(setLoader(true));
    const requestOptions={
      method : 'GET',
      headers: { 'Content-Type': 'application/json', "Authorization": "Bearer "+ user.token},
    };
  
    fetch(`${baseUrl}floors?space_id=${requestData._id}`, requestOptions).then(res => {
      return res.json();
    }).then(data => {
    //   requestData.dispatch(setLoader(false))
      requestData.dispatch(setFloors(data.data.docs))
    }).catch(err => {
      console.log(err)
    })
  }

export const conversionDailyRequest = (requestData) => {
    requestData.dispatch(setLoading(true));
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(requestData.params),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer " + user.token },
    };

    fetch(baseUrl + "sales/dailySales", requestOptions).then(res => {
        // fetch(baseUrl+"footfall/lineGraph", requestOptions).then(res => {
        return res.json();
    }).then(data => {
        if (data.status === true) {
            requestData.dispatch(setConversionDailyData(data.data));
        }
        requestData.dispatch(setLoading(false));
    }).catch(err => {
        console.warn(err);
        requestData.dispatch(setLoading(false));
    });
};

export const conversionTotalRequest = (requestData) => {
    requestData.dispatch(setConversionLoader(true));
    const requestOptions = {
        method: "POST",
        body: JSON.stringify(requestData.params),
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
        },
    };

    fetch(baseUrl + "sales/getTotalCount", requestOptions)
        .then((res) => {
            return res.json();
        })
        .then((data) => {
            console.log(data);
            if (data.status === true) {
                requestData.dispatch(setConversionTotal(data.data));
            }
            requestData.dispatch(setConversionLoader(false));
        })
        .catch((err) => {
            console.warn(err);
            requestData.dispatch(setConversionLoader(false));
        });
};

export  const singleSpaceFetch =(requestData) => {
    const requestOptions={ 
      method : 'GET',
      headers: { 'Content-Type': 'application/json', "Authorization": "Bearer "+ user.token}, 
    };
  
    fetch(`${baseUrl}spaces/${requestData._id}`, requestOptions).then(res => {
      return res.json();
    }).then(data => {
       if(data.status=true)
       requestData.dispatch(setSpace(data.data));
    }).catch(err  => {
    //   requestData.dispatch(setClient(false));
      console.warn(err);
    });
  }

  export const getEmployeRequest = (requestData) => {
    const requestOptions={ 
        method : 'GET',
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer "+ user.token}, 
      };
    
      fetch(`${baseUrl}employee?sid=${requestData._id}&limit=100&page=1`, requestOptions).then(res => {
        return res.json();
      }).then(data => {
         if(data.status=true)
         requestData.dispatch(setEmploye(data.data.docs));
      }).catch(err  => {
      //   requestData.dispatch(setClient(false));
        console.warn(err);
      });
      
  }

  export const getSectionofEmpoyeRequest = (requestData) => {
    requestData.dispatch(setLoading(true));


    const requestOptions={ 
        method : 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer "+ user.token}, 
      };
    
      fetch(`${baseUrl}employee_sale/employeeSaleData`, requestOptions).then(res => {
        return res.json();
      }).then(data => {
        requestData.dispatch(setLoading(false));

         if(data.status=true)

         requestData.dispatch(getSectionsOfEmploye(data.data));
      }).catch(err  => {
        requestData.dispatch(setLoading(false));

      //   requestData.dispatch(setClient(false));
        console.warn(err);
      });
      
  }

  
  export const getGraphOfEmployeeActivityRequest = (requestData) => {
    requestData.dispatch(setLoading(true));
    requestData.dispatch(setGraphLoader(false));
    const requestOptions={ 
        method : 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer "+ user.token}, 
      };
    
      fetch(`${baseUrl}dwelltime/employeeDwellData`, requestOptions).then(res => {
        return res.json();
      }).then(data => {
        requestData.dispatch(setLoading(false));
        requestData.dispatch(setGraphLoader(true));

            if(data.status=true)
         console.log('graphData',data);
         requestData.dispatch(getGraphOfEmployeActivity(data.data));
      }).catch(err  => {
        requestData.dispatch(setLoading(false));
        requestData.dispatch(setGraphLoader(true));

      //   requestData.dispatch(setClient(false));
        console.warn(err);
      });
      
  }

  export const employeSalesUnitRequest = (requestData) => {
    requestData.dispatch(setLoading(true));
    const requestOptions={ 
        method : 'POST',
        body: JSON.stringify(requestData),
        headers: { 'Content-Type': 'application/json', "Authorization": "Bearer "+ user.token}, 
      };
    
      fetch(`${baseUrl}employee_sale/SaleUnits`, requestOptions).then(res => {
        return res.json();
      }).then(data => {
        requestData.dispatch(setLoading(false));
        requestData.dispatch(setEmployeeSaleUnit(data.data))
      }).catch(err  => {
        requestData.dispatch(setLoading(false));
        console.warn(err);
      });
      
  }

  



